<template>
  <div v-if="parameter">
    <FormParameterInput :parameter="parameter" :value="value" @update:value="$emit('update:value', $event)" :title="title" :errors="errors" :required="parameter.required" :search-endpoint="searchEndpoint"/>
  </div>
</template>

<script>
import FormParameterInput from "@/components/forms/FormParameterInput.vue";

export default {
  name: "FormParameter",
  components: {FormParameterInput},
  emits: ["update:value"],
  props: {
    parameter: Object,
    value: [String, Number, Array, Boolean, Object],
    errors: [Array, Object],
    searchEndpoint: String,
    title: String
  }
}
</script>

<style scoped>

</style>